'use client';

import { Stack } from '@pie/amber';
import { useIdentityContext } from '@/components/IdentityContext';
import { PageHeader } from '@/components/Page/PageHeader';
import { PageContainer } from '@/components/Page/PageContainer';
import { PageContent } from '@/components/Page/PageContent';
import { YourPolicies } from './_components/YourPolicies';
import { RelatedArticles } from './_components/RelatedArticles';
import { HomePageDescription } from './_components/HomePageDescription';

export default function HomePage() {
  const { user } = useIdentityContext();

  return (
    <PageContainer accent>
      <PageHeader
        description={<HomePageDescription />}
        title={
          <>
            Welcome, <em>{user.givenName}</em>
          </>
        }
      />
      <PageContent>
        <Stack gap="layout-xl">
          <YourPolicies />
          <RelatedArticles />
        </Stack>
      </PageContent>
    </PageContainer>
  );
}
